import * as styles from './variants/formText.module.css';

import type { IFormText } from './types';

const FormText = ({
  className = '',
  variant = 'regular',
  ...props
}: IFormText) => (
  <div {...props} className={`${styles[variant]} ${className}`} />
);

export default FormText;
